module.exports = __webpack_public_path__ + "static/media/7@3x.381dd821.png";